<template>
  <error-boundary module="onboarding-module">
    <hr-module
      class="OnboardingModule"
      no-header
      mobile-header
      logo-left-panel
      left-panel-blue
    >
      <template v-slot:left>
        <hr-module-header
          :title="
            t('onboarding-module:title', {
              name: company.name,
              interpolation: { escapeValue: false },
            })
          "
          splashModule
        >
          <p>{{ t('onboarding-module:description') }}</p>
        </hr-module-header>
      </template>
      <template v-slot:right>
        <hr-steps main> </hr-steps>
      </template>
    </hr-module>
  </error-boundary>
</template>

<script>
import HrModule from '@/components/hr-module.vue';
import HrSteps from '@/components/hr-steps.vue';
import HrModuleHeader from '@/components/hr-module-header.vue';
import store from '@/store';
import router from '@/router';
import { computed } from 'vue';
import t from '@/lib/i18next';
import ErrorBoundary from '@/components/error-boundary.vue';
export default {
  name: 'onboarding-module',
  components: { ErrorBoundary, HrModule, HrSteps, HrModuleHeader },
  props: {
    onboardingId: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const company = computed(() => store.state.company);
    const session = computed(() => store.state.session);

    async function initialize() {
      // if has temp JWT token redirects to login page
      const keys = props.onboardingId.split(';');

      if (keys[1] || !session.value) {
        return router.push({
          name: 'login-module',
          params: { tempToken: props.onboardingId },
        });
      }

      await store.dispatch('getDocuments', props.onboardingId || session);
    }

    initialize();

    return {
      t,
      company,
    };
  },
};
</script>
